import { useRef } from "react";
import { useScroll, useTransform } from "framer-motion";

/**
 * useParallax — small helper that returns a transform y string
 * keyed to the parent section's scroll progress.
 *
 * @param {number} distance  number 0..1 (e.g. 0.2 = drift 20% of section height)
 * @returns { ref, y }       attach `ref` to the parent section, pass `y` to a motion element
 */
export function useParallax(distance = 0.2) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", `${distance * 100}%`]);
  return { ref, y };
}
